import React from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { ActionHandlerFunction, EmailGroup } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon, Loading } from "src/components";
import { MembersTable } from "..";


type AllProps = {
  is_loading: boolean;
  selected_group: EmailGroup;
  handleAction: ActionHandlerFunction;
}

// Description: Side panel component for displaying the details of a selected email group, including its members and an edit button.
function SidePanelComponent(props: AllProps) {
  const { is_loading, handleAction, selected_group } = props;

  return <Offcanvas show={true} placement="end" backdrop={false} className="sidebar narrower-panel">
    {is_loading && <div className="sidenav-group-loading">
      <Loading className="in-place" />
    </div>}

    {!is_loading && <>
      <Offcanvas.Header closeButton onHide={() => handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu })}>
        <Offcanvas.Title className="semi-bold" as="h2">
          {selected_group.alias}
          <Button
            variant="icon"
            onClick={() => handleAction({ actionType: AdminUIActionTypes.Edit, params: { selected_group } })}
            data-tooltip-id="pv-tooltip"
            data-tooltip-content="Edit Group"
            data-tooltip-place="left">
            <Icon className="ficon-edit-2" />
          </Button>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <h3>User Group Members</h3>
        {!!selected_group && <MembersTable members={selected_group.members}></MembersTable>}
      </Offcanvas.Body>
    </>}
  </Offcanvas>;
}

export default React.memo(SidePanelComponent);
